import { useAppStore } from "../../../GlobalStore/GlobalStore";
import Upload from "./Upload/Upload";
import StopRecording from "./StopRecording/StopRecording";

const MediaInput = () => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { recordingType } = dynamicStateObj;

    return (
        <>
            {recordingType !== "audio" ? (
                <Upload />
            ) : (
                <StopRecording />
            )}
        </>
    );
};

export default MediaInput;
